/**
 * Неподвижный гигант / заказчик (локация из GDD).
 * Стабильные строковые id — канон v3 (map / presentation).
 */
export const GIANT_IDS = [
  'serj',
  'mona',
  'duck',
  'willy',
  'roza',
  'svami',
  'factor',
  'yetti',
  'drakochi',
  'sol',
  'mu',
] as const;

export type GiantId = (typeof GIANT_IDS)[number];

/**
 * Играбельный курьер (персонаж раннера из таблицы GDD).
 * Стабильные id — канон v3 (select_character / CharacterStats).
 */
export const COURIER_IDS = ['eddy', 'claudi', 'tuchi', 'ufo', 'vall', 'rock'] as const;

export type CourierId = (typeof COURIER_IDS)[number];

/** Alias для UI выбора персонажа. */
export type CharacterId = CourierId;

export function isGiantId(value: string): value is GiantId {
  return (GIANT_IDS as readonly string[]).includes(value);
}

export function isCourierId(value: string): value is CourierId {
  return (COURIER_IDS as readonly string[]).includes(value);
}
